import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcBalance, IcPdf } from "../../Icons";
import axios from "axios";
import { Button, Table, Input, Label } from "reactstrap";
import Header from "../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../pdfUtils";

const fmt = (v) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(v) || 0);

function EstadoCuentaInterno() {
  const { user } = useContext(AuthContext);
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [movimientos, setMovimientos] = useState([]);
  const [status, setStatus] = useState("Pendiente");

  useEffect(() => {
    axios
      .get(`${URL_ESTADO_CUENTA}/interno${status ? `?status=${status}` : ""}`, auth)
      .then((response) => setMovimientos(response.data.movimientos))
      .catch(() => {});
  }, [status]); // eslint-disable-line

  const totalEntradas = movimientos
    .filter((m) => m.movimiento === "Entrada")
    .reduce((s, m) => s + m.monto, 0);
  const totalSalidas = movimientos
    .filter((m) => m.movimiento === "Salida")
    .reduce((s, m) => s + m.monto, 0);

  function generaPDF() {
    const doc = new jsPDF();
    const startY = pdfHeader(doc, "Estado de Cuenta Interno", status || "Todos");

    doc.autoTable({
      startY,
      head: [["Movimiento", "Tipo", "Fecha", "Monto", "Comisión Total", "Estatus"]],
      body: movimientos.map((m) => [
        m.movimiento, m.tipo, m.fecha, fmt(m.monto), fmt(m.comisionTotal), m.status,
      ]),
      ...pdfTableStyles(),
    });

    pdfFooter(doc);
    doc.save(`EstadoCuentaInterno_${status || "Todos"}.pdf`);
  }

  return (
    <>
      <Header />
      {user.menu_estadoCuenta ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcBalance style={{ marginRight: 8, color: "#8b5cf6" }} />
                Estado de Cuenta Interno
              </h3>
              <p className="page-subtitle">Movimientos por cobrar y cobrados</p>
            </div>
            <div className="page-actions">
              <Button color="danger" size="sm" onClick={generaPDF}>
                <IcPdf style={{ marginRight: 6 }} />
                PDF
              </Button>
            </div>
          </div>

          <div className="filter-bar">
            <div style={{ minWidth: 180 }}>
              <Label>Estatus</Label>
              <Input bsSize="sm" type="select" value={status}
                     onChange={(e) => setStatus(e.target.value)}>
                <option value="Pendiente">Pendiente</option>
                <option value="Cobrado">Cobrado</option>
                <option value="">Todos</option>
              </Input>
            </div>
          </div>

          <div className="stats-row">
            <div className="stat-chip">Entradas: <strong>{fmt(totalEntradas)}</strong></div>
            <div className="stat-chip">Salidas: <strong>{fmt(totalSalidas)}</strong></div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Movimiento</th>
                <th>Tipo</th>
                <th>Fecha</th>
                <th>Cuenta</th>
                <th style={{ textAlign: "right" }}>Monto</th>
                <th style={{ textAlign: "right" }}>Comisión Total</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              {movimientos.map((m) => (
                <tr key={`${m.movimiento}-${m._id}`}>
                  <td>
                    <span style={{
                      fontWeight: 600,
                      color: m.movimiento === "Entrada" ? "#059669" : "#dc2626",
                    }}>
                      {m.movimiento}
                    </span>
                  </td>
                  <td>{m.tipo}</td>
                  <td>{m.fecha}</td>
                  <td>{m.cuenta}</td>
                  <td style={{ textAlign: "right" }}>{fmt(m.monto)}</td>
                  <td style={{ textAlign: "right" }}>{fmt(m.comisionTotal)}</td>
                  <td>{m.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}
    </>
  );
}

export default EstadoCuentaInterno;
